/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/theater/details/desktop/closestTheaters.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'theater/details/desktop/closestTheaters', exports: {} };
const exports = module.exports;



import $ from '@take-2/fd-modules/jQuery';



import { Fandango_debugLog as debugLog } from '@take-2/fd-modules/splits/require-core';



import { fd_url_manager as links } from '@take-2/fd-modules/splits/require-core';



import { swig as swig } from '@take-2/fd-modules/splits/require-core';



import { Fandango_xhr as xhr } from '@take-2/fd-modules/splits/require-core';



const LIMIT = 7


const Selectors = {
    THEATER_ID: '.js-tdp',
    NEARBY_CONTAINER: '.js-closestTheaters-lazy',
    ERROR_ELS: '.js-closestTheaters-fail'
}


const DataAttributes = {
    THEATER_ZIP: 'theater-zip'
}
function excludeCurrentTheater(theaters) {
    const currentTheaterId = $(Selectors.THEATER_ID).data().theaterId;
    const newData = theaters.filter((theater) => {
        if (currentTheaterId !== theater.id) {
            return theater;
        }
    });
    return newData;
}
function errorHandler() {
    $(Selectors.ERROR_ELS).addClass('hide');
}
function onFail(err) {
    debugLog.warn('nearTheatersFail', err);
    return errorHandler();
}
function onDone(data) {
    if (!data || data.error || !data.theaters) {
        return errorHandler();
    }
    const viewModel = excludeCurrentTheater(data.theaters);
    if (viewModel.length === LIMIT) {
        viewModel.pop(); // this is hack together until we know all business logic for this module
    }
    const $markup = $(swig.render('_closestTheaters', {
        theaters: viewModel
    }));
    $(Selectors.NEARBY_CONTAINER).html($markup);
}
function init() {
    xhr.ajax({
        method: 'GET',
        url: links.napiNearbyTheaters(),
        data: {
            limit: LIMIT,
            zipCode: $(Selectors.NEARBY_CONTAINER).data(DataAttributes.THEATER_ZIP)
        },
    })
        .done(onDone)
        .fail(onFail);
}
export default {
    init,
};
